import { trigger, style, transition, animate, query, stagger } from '@angular/animations'

export const staggerFadeInAnimation = trigger('staggerFadeIn', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({ opacity: 0, transform: 'translateY(30px)' }),
                stagger(150, [
                    animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
                ]),
            ],
            { optional: true },
        ),
    ]),
])

export const fadeInUpAnimation = trigger('fadeInUp', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(30px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
    ]),
])
